import { render, staticRenderFns } from "./FireClaimPost.vue?vue&type=template&id=4ca939a8&"
import script from "./FireClaimPost.vue?vue&type=script&lang=js&"
export * from "./FireClaimPost.vue?vue&type=script&lang=js&"
import style0 from "./FireClaimPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FireClaimPost.vue"
export default component.exports